import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row justify-center" }
const _hoisted_2 = { class: "row justify-center q-mb-sm full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ref_button = _resolveComponent("ref-button")
  const _component_answer_button = _resolveComponent("answer-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.refButtons, (button, index) => {
        return (_openBlock(), _createBlock(_component_ref_button, {
          key: index,
          button: button,
          onClick: ($event: any) => (_ctx.clickOnButton(button))
        }, null, 8, ["button", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode(_component_answer_button, {
      button: _ctx.continueButton,
      onClickButtonWithPayload: _cache[1] || (_cache[1] = payload => _ctx.$emit('click-button-with-payload', payload)),
      class: "continue-button"
    }, null, 8, ["button"])
  ]))
}